"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.691 5.038A.5.5 0 0 1 12 5.5v13a.5.5 0 0 1-.854.354L7.293 15H4.5A1.5 1.5 0 0 1 3 13.5v-3A1.5 1.5 0 0 1 4.5 9h2.793l3.853-3.854a.5.5 0 0 1 .545-.108M16.8 6.1a.5.5 0 0 0-.6.8C18.09 8.318 19 10.176 19 12s-.91 3.682-2.8 5.1a.5.5 0 0 0 .6.8c2.11-1.582 3.2-3.723 3.2-5.9 0-2.176-1.09-4.318-3.2-5.9"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M14.854 9.146a.5.5 0 0 0-.708.708c.67.67.979 1.422.979 2.146 0 .725-.309 1.477-.979 2.147a.5.5 0 0 0 .708.707c.83-.83 1.271-1.828 1.271-2.854 0-1.025-.441-2.023-1.271-2.854"
  })]
}), 'VolumeFilled');
//# sourceMappingURL=index.js.map